import logo from "../assets/logo.png";

export function Footer({ onImpressum }: { onImpressum: () => void }) {
  return (
    <footer className="bg-stone-900 text-sand-200 py-8 border-t border-sand-100/10">
      <div className="max-w-6xl mx-auto px-5 lg:px-10">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <img src={logo} alt="ziel balance" className="h-14 w-auto" />

          <p className="text-xs text-sand-200/60 font-light text-center">
            © {new Date().getFullYear()} ziel balance · Christine Pfeifle-Rauch · Waldburg
          </p>

          <button
            onClick={onImpressum}
            className="text-xs text-sand-200/70 hover:text-sand-50 transition-colors duration-200 font-medium tracking-wider uppercase"
          >
            Impressum
          </button>
        </div>
      </div>
    </footer>
  );
}
